// ================================
// Vrindaa Cart Popup
// ================================

const vrindaaPopup = document.getElementById("vrindaa-cart-popup");
const vrindaaClose = document.getElementById("vrindaaClose");
// ====================================
// Vrindaa Cart Popup
// ====================================

document.addEventListener("DOMContentLoaded", function () {


  const popup = document.getElementById("vrindaa-cart-popup");
  const closeBtn = document.getElementById("vrindaaClose");

  let vrindaaSelectedKey = null;



  // Close popup X button
  closeBtn?.addEventListener("click", function(){

    popup.classList.remove("active");

  });



  // Close popup overlay click
  popup?.addEventListener("click", function(e){

    if(e.target === popup){

      popup.classList.remove("active");

    }

  });



  // ====================================
  // Open Remove Popup
  // ====================================


  document.querySelectorAll(".vrindaa-remove-trigger").forEach(btn => {


    btn.addEventListener("click", function(e){


      e.preventDefault();


      vrindaaSelectedKey = this.dataset.key;


      popup.classList.add("active");


    });


  });





  // ====================================
  // Remove Item
  // ====================================


  document.getElementById("vrindaaRemoveBtn")?.addEventListener("click", function(){


    if(!vrindaaSelectedKey) return;



    fetch('/cart/change.js',{

      method:'POST',

      headers:{
        'Content-Type':'application/json'
      },

      body:JSON.stringify({

        id:vrindaaSelectedKey,

        quantity:0

      })

    })

    .then(()=>{

      location.reload();

    });



  });






  // ====================================
  // Move To Wishlist (Swym)
  // ====================================


  document.getElementById("vrindaaWishlistBt")?.addEventListener("click", function(){



    console.log("Wishlist process started");



    if(!vrindaaSelectedKey){

      console.log("No cart item selected");

      return;

    }




    fetch('/cart.js')

    .then(response=>response.json())

    .then(cart=>{


      let item = cart.items.find(

        item => item.key === vrindaaSelectedKey

      );



      if(!item){

        console.log("Item not found");

        return;

      }




      SwymCallbacks.push(function(){



        let productData = {


          epi: String(item.variant_id),


          empi: String(item.product_id),


          du: window.location.origin + item.url,


          dt: item.product_title,


          iu: item.image,


          pr: item.final_price / 100



        };




        console.log("Sending to Swym", productData);



        
        _swat.addToWishList(productData,function(){



          console.log("Added to wishlist");



          fetch('/cart/change.js',{

            method:"POST",

            headers:{

              "Content-Type":"application/json"

            },

            body:JSON.stringify({

              id:vrindaaSelectedKey,

              quantity:0

            })

          })


          .then(()=>{

            location.reload();

          });



        });



      });



    });



  });



});